import { Injectable } from '@angular/core';

/**
 * Summary  The component to Configuration Routes
 *
 * @file    This file define Configuration Routes as routes
 * @author  Andres David Betin Rodriguez.
 * @since   2019-08-06
 */

@Injectable()
export class StringHelperService {

  private listAddres: {
    catalog_address: { [key: string]: string },
  } = {
    catalog_address: {
      'AGRUPACION': 'AG',
      'APARTADO AEREO': 'A.A.',
      'APARTAMENTO': 'AP',
      'APTO': 'AP',
      'APT': 'AP',
      'AUTOPISTA': 'AUTOP',
      'AVENIDA CALLE': 'AV CL',
      'AVENIDA CARRERA': 'AV KR',
      'AVENIDA': 'AV',
      'BARRIO': 'BRR',
      'BLOQUE': 'BL',
      'BODEGA': 'BG',
      'CALE': 'CL',
      'CALLE': 'CL',
      'CLL': 'CL',
      'Cl': 'CL',
      'CAMINO': 'CAMINO',
      'CARRERA': 'KR',
      'CARRETERA': 'CT',
      'CR': 'KR',
      'KRA': 'KR',
      'CRA': 'KR',
      'CASA': 'CS',
      'CELULA': 'CEL',
      'CENTRO ADMINISTRATIVO NACIONAL': 'CAN',
      'CENTRO COMERCIAL': 'CCO',
      'CENTRO': 'CEN',
      'CIRCULAR': 'CIRCULAR',
      'CONJUNTO': 'CONJ',
      'CONSULTORIO': 'CONS',
      'DEPOSITO': 'DP',
      'DIAGONAL': 'DG',
      'DIAG': 'DG',
      'EDIFICIO': 'ED',
      'ENTRADA': 'ENT',
      'ESQUINA': 'ESQ',
      'ESTE': 'EST',
      'ETAPA': 'ET',
      'GARAGE SOTANO': 'GS',
      'GARAJE': 'GJ',
      'INTERIOR': 'INT',
      'KILOMETRO': 'KM',
      'LOCAL': 'LC',
      'LOTE': 'LT',
      'SUPERMANZANA': 'SPMZ',
      'MANZANA': 'MZ',
      'MEZZANINE': 'MEZZ',
      'MODULO': 'MOD',
      'MUNICIPIO': 'MCP',
      'NORTE': 'NTE',
      'NO': '',
      'NO.': '',
      'OCCIDENTE': 'OCC',
      'OESTE': 'OE',
      'OFICINA': 'OF',
      'PARCELA': 'PA',
      'PASEO': 'PASEO',
      'PENTHOUSE': 'PH',
      'PISO': 'PI',
      'PREDIO': 'PD',
      'PUENTE': 'PTE',
      'PUESTO': 'PTO',
      'SALON COMUNAL': 'SC',
      'SECTOR': 'SECT',
      'SEMISOTANO': 'SS',
      'SOLAR': 'SL',
      'SOTANO': 'ST',
      'SUR': 'SUR',
      'TORRE': 'TRR',
      'TRANSVERSAL': 'TV',
      'UNIDAD RESIDENCIAL': 'UR',
      'UNIDAD': 'UN',
      'URBANIZACION': 'URB',
      'VEREDA': 'VEREDA',
      'VIA': 'VIA',
      'ZONA': 'ZN',
    },
  };

  normalizeAddress(address: string, addressDetail: string): string {
    let str = (`${address} ${addressDetail}`).toLowerCase();
    const ltr = ['[àáâãä]', '[èéêë]', '[ìíîï]', '[òóôõö]', '[ùúûü]', 'ñ', 'ç', '[ýÿ]', '\\W|_'];
    const rpl = ['a', 'e', 'i', 'o', 'u', 'n', 'c', 'y', ' '];

    for (let i = 0; i < ltr.length; i++) {
      const rgx = new RegExp(ltr[i], 'g');
      str = str.replace(rgx, rpl[i]);
    }

    str = str.replace(/  +/g, ' ');

    // tslint:disable-next-line:forin
    for (const k in this.listAddres.catalog_address) {
      // if (!k) { continue; }
      const rgx1 = new RegExp('^' + k.toLowerCase() + '\\s', 'g');
      const rgx2 = new RegExp('\\s' + k.toLowerCase() + '\\s', 'g');
      const rgx3 = new RegExp('\\s' + k.toLowerCase() + '$', 'g');
      str = str.replace(rgx1, this.listAddres.catalog_address[k].toLowerCase() + ' ');
      str = str.replace(rgx2, ' ' + this.listAddres.catalog_address[k].toLowerCase() + ' ');
      str = str.replace(rgx3, ' ' + this.listAddres.catalog_address[k].toLowerCase());
    }
    str = str.trim();
    return str.toUpperCase();
  }

  normalizeCompany(company: string): string {
    return company.replace(/\s{2,}/g, ' ').replace(/&/g, 'y').trim();
  }
}
